/* eslint-disable */

import axios from 'axios';
import localAuthServices from '../localAuthServices';

const SSOApiService = axios.create({ timeout: 50000 })

SSOApiService.interceptors.request.use(function (config) {
  const token = localAuthServices.getToken();
  process.env.NODE_ENV === 'development' ? config.baseURL = 'https://uat-global-public-sso.capitaldynamics.biz/' : config.baseURL = 'https://global-public-sso.capitaldynamics.biz/';

  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

export default SSOApiService;
